import React from 'react'

export const Servicios = () => {
  return (
    <div className='page'>
        <h1 className='heading'>Servicios</h1>

        <section>
            <article className='service'>
                <h2>Mantenimiento</h2>
                <p>Limpieza de partes mecanicas y electricas del Ascensor tomando en cuenta el mantenimiento preventivo de piezas mecanicas y electricas con desgastes</p>
            </article>

            <article className='service'>
                <h2>Solucion de averias</h2>
                <p>Diagnosticos y solucion de fallas en equipos detenidos</p>
            </article>

            <article className='service'>
                <h2>Reparaciones</h2>
                <p>Instalacion de respuestos electricos y mecanicos tales como: cambio de botones, mallas infrarojas, contactos, correas, piolas, entre otros</p>
            </article>

            <article className='service'>
                <h2>Entrenamiento para rescate de pasajeros</h2>
                <p>Charla teorica y practica sobre el rescate de pasajeros en un ascensor de manera correcta y segura sin poner en riesgo la vida del usurio</p>
            </article>

            <article className='service'>
                <h2>Inspecciones</h2>
                <p>Realizar inspeccion a equipos con informe fotografico a detalle tomando enfasis en la normativa</p>
            </article>

            <article className='service'>
                <h2>Supervición</h2>
                <p>Organizacion de calendario y rutas de mantenimiento, manejo de personal tecnico, visitas a terreno</p>
            </article>
        </section>
    </div>
  )
}
